import { createExportHandlers } from '@src/main/modules/messages/utils/createExportHandlers';
import { normalizePositionAssignmentReport } from '@src/main/modules/messages/utils/formatters';
import { PositionAssignmentReport } from '@src/main/modules/reports/shared/domain/report.interface';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const usePositionAssignmentExport = (
  evaluations: PositionAssignmentReport[],
  fileName: string,
) => {
  const { t } = useTranslation();

  return useMemo(
    () => createExportHandlers(evaluations, normalizePositionAssignmentReport, fileName, t),
    [evaluations, fileName, t],
  );
};
